import { render, staticRenderFns } from "./MavBatchDialog.vue?vue&type=template&id=37ea3a7a&scoped=true"
import script from "./MavBatchDialog.vue?vue&type=script&lang=js"
export * from "./MavBatchDialog.vue?vue&type=script&lang=js"
import style0 from "./MavBatchDialog.vue?vue&type=style&index=0&id=37ea3a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ea3a7a",
  null
  
)

export default component.exports